// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(inventory)/branch/_layout/reports/out-of-stock/-components/component";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import { GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";
import { pharmacyClient } from "@/connect";
import { ItemType } from "@/gen/inventory/common_pb";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/out-of-stock/")({
  component: Component,
  validateSearch: SearchParams,
});
